<template>
  <div class="search-input-wrap">
    <el-input
      ref="searchInput"
      class="search-input"
      placeholder="请输入课程名称"
      size="medium"
      v-model.trim="keyword"
      @keyup.enter.native="onSearch"
      maxlength="100"
      @focus="handleSearchFocus"
      @blur="handleSearchBlur"
      @input="handleInput"
    >
      <i
        slot="suffix"
        class="el-input__icon el-icon-search"
        @click.stop="onSearch"
      ></i>
    </el-input>
    <!-- 搜索历史 -->
    <div v-if="showHistory" class="search-result-wrap">
      <div class="title-wrap">
        <p class="cont-name">搜索历史</p>
        <button class="clear-btn" @mousedown="handleDelKeyword()">清空</button>
      </div>
      <ul class="history-list">
        <li
          @mousedown.stop="handleKeywordClick(item)"
          v-for="item in keywords"
          :key="item"
          class="item"
        >
          <p class="cont">
            {{ item }}
          </p>
          <button @mousedown.stop="handleDelKeyword(item)">
            <i class="el-icon-close"></i>
          </button>
        </li>
      </ul>
    </div>
    <!-- 搜索结果 -->
    <div v-if="showResult" class="search-result-wrap">
      <div v-if="courseInfo.id" class="course-result">
        <p class="cont-name">课程</p>
        <div
          @mousedown="jumpPage('/product-detail/' + courseInfo.id)"
          class="course-info"
        >
          <p class="title">
            <span class="tag">{{ courseInfo.category_name }}</span>
            <span v-html="handleKeyWordHilight(courseInfo.course_name)"></span>
          </p>
        </div>
      </div>
      <div v-if="orgInfo.org_id" class="org-result">
        <p class="cont-name">机构</p>
        <div @mousedown="jumpPage('/org/' + orgInfo.org_id)" class="org-info">
          <img class="logo" :src="handleOrgLogo" alt="" />
          <div class="info-wrap">
            <p class="name" v-html="handleKeyWordHilight(orgInfo.org_name)"></p>
            <p class="desc">
              {{ orgInfo.org_desc }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrganizationList } from "@saas/server-api/src/organization";
import { getCourseList } from "@saas/server-api/src/course";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { isMobile } from "@saas/components/src";
import { getComettechCdnUrl } from "@saas/components/src/utils/assets";
export default {
  data: function () {
    return {
      orgInfo: {},
      courseInfo: {},
      showResult: false,
      showHistory: false,
      keyword: "",
      isMobile: isMobile(),
    };
  },
  methods: {
    ...mapMutations("searchHistory", ["addKeyword", "delKeyword"]),
    jumpPage(url) {
      setTimeout(() => {
        if (window.isElectron || this.isMobile) {
          this.$router.push(url);
        } else {
          window.open(url);
        }
      }, 0);
    },
    handleKeywordClick(item) {
      this.keyword = item;
      this.onSearch();
    },
    handleDelKeyword(item) {
      this.delKeyword(item);
      if (!this.keywords?.length) {
        this.showHistory = false;
      } else {
        this.clickKeyword = true;
      }
    },
    handleInput(value) {
      if (value) {
        // 搜索
        this.getSearchResult(value);
      } else {
        this.handleSearchFocus();
      }
    },
    handleSearchFocus() {
      if (this.keywords?.length) {
        this.showResult = false;
        this.showHistory = true;
      } else {
        this.showResult = false;
        this.showHistory = false;
      }
    },
    getSearchResult(value) {
      let params = {
        page_no: 1,
        page_size: 1,
      };
      Promise.all([
        getCourseList({
          ...params,
          course_name: value,
        }),
        getOrganizationList({
          ...params,
          org_name: value,
        }),
      ]).then(([courseRes, orgRes]) => {
        if (courseRes?.data?.list?.length || orgRes?.data?.list?.length) {
          this.showResult = true;
          this.showHistory = false;
          if (orgRes?.data?.list?.length) {
            this.orgInfo = orgRes.data.list[0];
          } else {
            this.orgInfo = {};
          }
          if (courseRes?.data?.list?.length) {
            this.courseInfo = courseRes.data.list[0];
          } else {
            this.courseInfo = {};
          }
        } else {
          this.showResult = false;
          this.showHistory = false;
        }
      });
    },
    handleSearchBlur() {
      if (!this.clickKeyword) {
        this.showHistory = false;
        this.showResult = false;
      }
      this.clickKeyword = false;
    },
    onSearch() {
      if (this.keyword) {
        this.addKeyword(this.keyword);
        this.showHistory = false;
        this.showResult = false;
        if (this.$route.name === "SearchResult") {
          EventBus.$emit("keyword", this.keyword);
        } else {
          // 失焦
          this.$refs?.searchInput?.blur();
          setTimeout(() => {
            let url = `/search-result?keyword=${this.keyword}`;
            if (window.isElectron || this.isMobile) {
              this.$router.push(url);
            } else {
              window.open(url);
            }
          }, 0);
        }
      }
    },
  },
  computed: {
    ...mapState("searchHistory", ["keywords"]),
    handleKeyWordHilight() {
      return (str) => {
        if (!str) return "";
        const regex = new RegExp(this.keyword, "g");
        return str.replace(
          regex,
          `<span class="highlight">${this.keyword}</span>`
        );
      };
    },
    //机构logo
    handleOrgLogo() {
      if (this.orgInfo?.org_logo) {
        return this.orgInfo.org_logo + "?imageView2/0/w/100";
      } else {
        return getComettechCdnUrl("/cdn/static/images/default_org_logo.png", "?imageView2/0/w/100");
      }
    },
  },
  watch: {
    // 监听路由对象中的查询参数部分，即query
    "$route.name": {
      immediate: true, // 组件创建时立即触发
      handler(newValue) {
        if (newValue === "SearchResult") {
          this.keyword = this.$route.query.keyword;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input-wrap {
  position: relative;
}
.search-result-wrap {
  padding-bottom: 14px;
  position: absolute;
  top: 43px;
  width: 300px;
  background: #ffffff;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: 1px solid #e5e6e8;
  .cont-name {
    padding-top: 14px;
    font-size: 12px;
    color: #858687;
    line-height: 17px;
    padding-left: 14px;
  }
  .title-wrap {
    padding: 14px 14px 12px;
    display: flex;
    justify-content: space-between;
    .cont-name {
      padding-top: 0;
      padding-left: 0;
    }
  }
  .clear-btn {
    font-size: 12px;
    color: #858687;
    line-height: 17px;
  }
  .history-list {
    padding: 0 6px;
    .item {
      background: #f7f8fa;
      border-radius: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px 0 8px;
      height: 32px;
      margin-bottom: 6px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .cont {
      font-size: 12px;
      color: #1d2129;
      line-height: 17px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-icon-close {
      font-size: 14px;
      color: #717172;
      margin-left: 12px;
    }
  }
  .course-info {
    font-weight: 500;
    font-size: 12px;
    color: #0d1400;
    line-height: 17px;
    padding: 10px 8px;
    margin: 6px 6px 0;
    cursor: pointer;
    &:hover {
      background: #f2f3f5;
    }
    border-radius: 6px;
    ::v-deep .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      .highlight {
        color: #00c89d;
      }
    }
    .tag {
      height: 16px;
      background: #f5f5f5;
      border-radius: 4px;
      font-weight: 500;
      font-size: 10px;
      color: #515350;
      line-height: 16px;
      margin-right: 6px;
      padding: 0 4px;
    }
  }
  .org-info {
    display: flex;
    align-items: center;
    margin: 6px 6px 0;
    padding: 10px 8px;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      background: #f2f3f5;
    }
    .logo {
      width: 40px;
      height: 40px;
      background: #ffffff;
      border-radius: 25px;
      border: 1px solid #e2e2e2;
      margin-right: 8px;
    }
    .info-wrap {
      flex: 1;
      width: 0;
    }
    .name,
    .desc {
      line-break: anywhere;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    ::v-deep .name {
      font-weight: 500;
      font-size: 12px;
      color: #000000;
      line-height: 17px;
      .highlight {
        color: #00c89d;
      }
    }
    .desc {
      margin-top: 2px;
      font-size: 11px;
      color: #515350;
      line-height: 16px;
    }
  }
}
.search-input {
  margin-right: 20px;
  width: 240px;
  .el-icon-search {
    cursor: pointer;
  }
}
::v-deep .search-input input {
  background: #f8fafc;
}
::v-deep .el-input__inner {
  border-radius: 8px;
  border: 2px solid #f1f5f9;
  transition: border-color 0.2s;
  &:focus {
    border-color: #34d399;
  }
}
::v-deep .el-input__inner::placeholder {
  font-size: 14px;
  color: #888988;
}
</style>
